export default "__VITE_PUBLIC_ASSET__1b365fa5__"